// import '../sass/style.css';
import React,{useState} from "react";

import{Modal,Button} from 'react-bootstrap';
import { Link } from "react-router-dom";
import {RiSettings3Line} from 'react-icons/ri'

import { IoMdInfinite } from "react-icons/io";




function CreateLinkPost(props){
    const [show, setShow]=useState(false);
    const [postLabel,setPostLabel]=useState(false)
    const [inputValue,setInputValue]=useState("")
    const handleClose =()=>setShow(false);
    const handleShow =()=>setShow(true);
    // const [newPost,setNewPost]=useState({
    //     title:"",
    //     description:""
    // })
const handleInputChange=(event)=>{
    setInputValue(event.target.value)
}

// const handleTogglePostLabel=(event)=>{
//     setPostLabel((current)=>!current)
// }

return(
    <>
<p className="border-0" variant="white"  onClick={handleShow}>
<div style={{background:"rgb(0, 207, 53)"}} className='rounded-circle'>
<Link className='' >
    <h1 className='rounded-circle mt-3 text-white fs-3' style={{transform:"rotate(-30deg)"}}> <IoMdInfinite/> </h1>
  </Link>
</div>

  Link
</p>

<Modal className="modal"  show={show} onHide={handleClose}>
<Modal.Header  className="d-flex justify-content-between"  >

<Modal.Title>
<p className="user fw-bold fs-6">centeee</p> 

</Modal.Title>

<p className="fw-bolder fs-4"> <RiSettings3Line/></p>

</Modal.Header>

<Modal.Body>


<div className="line "></div>
<div >
<label  className="fs-5 row  justify-content-center text-center " style={{background:"whitesmoke"}} >

<textarea className="form-control border-0 border-white p-3" placeholder="Type or place link" style={{background:"whitesmoke"}}></textarea>

</label>



</div>
<div className="line "></div>
     
<textarea
    className='form-control border-0 p-2 border-white'
      type="text "
  
    placeholder="Go ahead and put anything"
     />
     <br />

<input type="text" className="form-control border-0 border-white"
    placeholder="#tags"
 />

</Modal.Body>

<Modal.Footer className="d-flex justify-content-between">

<div className="  ">
<Button variant="light" className=" text-start rounded-pill text-dark border-1  ps-4 pe-4 " onClick={handleClose} style={{background:"rgb(134, 132, 132)"}}>
Close

</Button>
</div>

<div className="dropdown">
  <button className="bg-white  rounded-pill btn btn-secondary dropdown-toggle text-decoration-none p-2 text-black fw-bolder" type="button" data-bs-toggle="dropdown" aria-expanded="false"
  style={{border:"3px solid gray"}}

  >
    Everyone
  </button>

   <ul className="dropdown-menu">
   <li className="fw-bolder">Community labels</li>
    <li><Link className="dropdown-item">Mature</Link></li>
    <li><Link className="dropdown-item" > Drug and alcohol addication</Link></li>
    <li><Link className="dropdown-item" >Violence</Link></li>
    
  </ul>


</div>


</Modal.Footer>


</Modal>




    </>
)

}
export default CreateLinkPost